<template>
  <div class="container">

    <div class="main">
      <div class="title">
        <p>患者列表</p>
      </div>

      <div class="card" id="table_card">
        <div class="row1">
          <span class="text" v-show="false" >科室</span>
          <select class="sel" v-model="typeSelect" >
            <option value="all">全部</option>
            <option value="used">使用中</option>
            <option value="noused">未使用</option>
          </select>

          <div class="search">
            <input type="text" v-model="searchWord" placeholder="请输入姓名或手机号" @keyup="startSearch"/>
            <img src="/static/report/icon_search.png" />
          </div>
        </div>

        <div class="table_wrap">
          <table>
            <tr class="header">
              <td v-for="(item,index) of headerList" width="15%">
                {{ item.label }}
              </td>
            </tr>
            <tr :key="item.name" v-for="(item, index) in tablist" class="content" :class="{'gray':!(index%2)}">
              <td v-html="item.name"></td>
              <td v-if="!flagTypeFollow">{{item.dept}}</td>
              <td v-html="item.username"></td>
              <td >{{ item.glucose}}</td>
              <td v-if="!flagTypeFollow">{{item.cureNo}}</td>
              <td class="op" @click="viewReportPrepare(index)">查看</td>
            </tr>
          </table>
        </div>

        <div class="page_row">
          <el-button @click="prevPage()">上一页
          </el-button>
          <span>{{pageInfo.curIndex+1}}/{{pageInfo.pageNum}}</span>
          <el-button @click="nextPage()">下一页
          </el-button>
        </div>

      </div>
    </div>

    <ReportFooter />
  </div> <!--container结束-->
</template>

<script>
  // import echarts from 'echarts'
  import auth from '../auth/auth'
  import ReportFooter from './ReportFooter'
  export default {
    components: { ReportFooter},
    data() {
      return {
        patientList:[],
        tablist:[],
        total:[],
        saveTotal:[],
        pageInfo:{
          curIndex:0,
          pageNum:0
        },
        perPage:8,
        flagTypeFollow:false,
        searchWord:sessionStorage.getItem('WeitanReportInput')||'',
        typeSelect:sessionStorage.getItem('weitanTypeSelect')||'all',
        headerList:[
          {label:'姓名'},
          {label:'科室'},
          {label:'手机号'},
          {label:'血糖值mmol/L'},
          {label:'住院号/门诊号'},
          {label:'操作'},
        ]
      }
    },
    computed:{
     
    },
    watch:{
      typeSelect(){
        sessionStorage.setItem('weitanTypeSelect',this.typeSelect)
        this.updatePage(0);
      }
    },
    mounted(){
      let app_type =sessionStorage.getItem('app_type')
      if(app_type=='EasyFollow'){
        this.flagTypeFollow =true
        this.headerList =[
          {label:'姓名'},
          {label:'手机号/邮箱'},
          {label:'血糖值mmol/L'},
          {label:'操作'},
        ]
      }
      let req=this.getRequest()
      this.cureNo = req.cureNo;

      this.$http.post('/api/v2.1/monitor/connections', {
        per_page:9999,
      }).then(function (res) {
        if (0==res.data.error) {
          let datas =res.data.data.items.sort(function(a,b){
            
            if(a.create_time<b.create_time){
              return 1
            }else{
              return -1
            }
          })
          this.total =[]
          let name =sessionStorage.getItem('username')
          let created_by =sessionStorage.getItem('created_by')
          
          if(created_by =='register'){
            this.total=datas
          }else{
            for(let i=0;i<datas.length;i++){
              let str =datas[i].data.follow_list.join(',')
              let arr=str.toLocaleLowerCase().split(',')
              if(arr.includes(name.toLocaleLowerCase())){
                this.total.push(datas[i])
              }
            }
          }
          
          for(let j=0;j<this.total.length;j++){
            let item=this.total[j]
            item.used='noused'
            if(item.sensor_status){
              if(item.sensor_status.updateTime){
                  let num =(new Date().getTime()-item.sensor_status.updateTime*1000)/3600000
                  if(num<1){
                    item.used='used'
                  }
              }
            }
          }
          this.saveTotal = this.total;
          this.pageInfo.pageNum = Math.ceil(this.total.length/this.perPage);
          this.pageInfo.curIndex = this.$store.state.patientPage
          // this.updatePage(this.pageInfo.curIndex);
          // this.typeSelect =sessionStorage.getItem('weitanTypeSelect')||'all'
          this.pageInfo.curIndex = Number(sessionStorage.getItem('weitanCurIndex'))||0
          this.updatePage(this.pageInfo.curIndex)
        } else {
        }
      }, function (err) {

      })

    },
    methods: {
      startSearch() {
        this.updatePage(0)
      },
      prevPage(){
        if (this.pageInfo.curIndex>0) {
         
          this.updatePage(this.pageInfo.curIndex-1);
        }
      },
      nextPage(){
        if (this.pageInfo.curIndex < (this.pageInfo.pageNum - 1)) {
        
          this.updatePage(this.pageInfo.curIndex+1);
        }
      },

      updatePage(pageIndex) {
        if (!this.searchWord) {
          this.total = this.saveTotal;
          this.pageInfo.pageNum = Math.ceil(this.total.length/this.perPage);
        }else{
          let searchTotal=[];
      
          for (let i=0; i<this.saveTotal.length; i++) {
            let item=this.saveTotal[i];
            let copyItem = {...item};
            let name = item.alias||'';
            if(this.flagTypeFollow){
              name=item.real_name||''
            }
            let mobile ='';
            if(item.username.match(/^[\d]{11}$/)){
              mobile = item.username;
            }
            
            if (name.indexOf(this.searchWord)>=0 || mobile.indexOf(this.searchWord)>=0) {
              if(this.flagTypeFollow){
                copyItem.real_name = name.replace(this.searchWord, '<span style="color: lightcoral">'+this.searchWord+'</span>')
              }else{
                copyItem.alias = name.replace(this.searchWord, '<span style="color: lightcoral">'+this.searchWord+'</span>')
              }
             
              
              copyItem.username = mobile.replace(this.searchWord, '<span style="color: lightcoral">'+this.searchWord+'</span>')
              searchTotal.push(copyItem)
            }
          }
          this.total = searchTotal;
        }
        sessionStorage.setItem('WeitanReportInput',this.searchWord)

        let totalSe =[]
        if(this.typeSelect=='all'){
          totalSe=this.total
        }else{
          for(let k=0;k<this.total.length;k++){
            if(this.total[k].used==this.typeSelect){
              totalSe.push(this.total[k])
            }
          }
        }
        
        let size=totalSe.length; 
        this.pageInfo.pageNum = Math.ceil(size/this.perPage);
        let curIndex = pageIndex;
        let perPage = this.perPage;
        this.pageInfo.curIndex = curIndex;
        sessionStorage.setItem('weitanCurIndex',curIndex)

        let patientList=[];
        for (let i=0; i<perPage; i++) {
          let pos = curIndex*perPage+i;
          if (pos >= size) {
            break;
          }
          let itemSe=totalSe[pos];
          
          let patientInfo={};
          patientInfo.name = itemSe.alias;
          patientInfo.uid = itemSe.uid;
         
          patientInfo.username = itemSe.username;
          patientInfo.followID = itemSe.follow_id || '';
          patientInfo.glucose='--'
          // 新增信息
        
          if(itemSe.data){
            if(itemSe.data.follow_gender){
                patientInfo.sex=itemSe.data.follow_gender=='1'?'男':'女'
            }else{
              itemSe.data.follow_gender =''
            }
            patientInfo.dept = itemSe.data.follow_department;
            patientInfo.cureNo = itemSe.data.HospitalNumber;
            patientInfo.follow_diagnosis = itemSe.data.follow_diagnosis;
            patientInfo.birthday = itemSe.data.birthday;
            patientInfo.bed = itemSe.data.bed;
            patientInfo.age=itemSe.data.age>0?itemSe.data.age:''
          }
          patientInfo.mobile=itemSe.username

          if(this.flagTypeFollow){
            patientInfo.name = itemSe.real_name
            patientInfo.birthday = itemSe.birth_date
            if(itemSe.gender=='GDRM'){
              patientInfo.sex = '男'
            }else if(itemSe.gender=='GDRF'){
              patientInfo.sex = '女'
            }else if(itemSe.gender=='GDRNF'){
              patientInfo.sex = ''
            }
          }
          if(itemSe.sensor_status){
            if(itemSe.sensor_status.updateTime){
                let num =(new Date().getTime()-itemSe.sensor_status.updateTime*1000)/3600000
                if(num<1){
                  patientInfo.glucose=itemSe.sensor_status.glucose.toFixed(1)||'--'
                  patientInfo.glucose=patientInfo.glucose==0?'--':patientInfo.glucose
                  patientInfo.glucose= patientInfo.glucose>22.2?'偏高':patientInfo.glucose
                  patientInfo.glucose=patientInfo.glucose<2.2?'偏低':patientInfo.glucose
                  
                }
            }
          }
          patientList.push(patientInfo)
        }
        this.patientList=patientList;
        this.tablist=this.patientList
       
       
      },

      onBtnLogin() {
      },
      viewReportPrepare (index) {
        let patientInfo = this.patientList[index];
        if(this.searchWord.length){
          const keys = ['mobile', 'name']
          keys.map(key => {
            if(patientInfo[key]&&patientInfo[key].match(/[<>]/)){
              let splitList = patientInfo[key].split(/[<>]/)
              patientInfo[key] = splitList[0] + splitList[2] + splitList[4]
            }
          })
        }
        sessionStorage.setItem('ReportPatientInfo', JSON.stringify(patientInfo));
        this.$store.commit('updatePatientPage', this.pageInfo.curIndex)
        this.$router.push('/reportPrepare');
      },
      getRequest() {
        let href = location.href;
        let theRequest={};
        if (href.indexOf("?") != -1) {
          let search =  href.substring(href.indexOf("?")+1)
          let strs = search.split("&");
          for (let i = 0; i < strs.length; i++) {
            let pair = strs[i].split("=");
            theRequest[pair[0]] = unescape(pair[1]);
          }

        }
        return theRequest;
      },

    },
  }
</script>

<style scoped>


  p,body,html {
    margin:0;
  }

  .container {
    min-height: 800px;
    background-color:#f4f4f4;
  }

  .container .main {
    width: 1200px;
    margin: 0 auto;
  }

  .container .main .title {
    font-family:Source Han Sans CN;
    font-weight:500;
    color:#000000;
    font-size:26px;
    padding-top: 30px;
    padding-left: 50px;
  }

  .container .main .card {
    margin-top: 15px;
    width: 100%;
    height:750px;
    background-color:#ffffff;
    border-radius:16px;
    box-shadow:0px 0px 12px rgba(0, 0, 0, 0.16);
  }

  #table_card .row1 {
    padding-top: 30px;
    padding-left: 40px;
    height:80px;
    border-bottom: solid 1px #707070;
  }

  #table_card .row1 .text {
    font-size:24px;
    float: left;
  }

  #table_card .row1 .sel {
    width:180px;
    height:32px;
    font-size:20px;
    float:left;
    margin-left:15px;
  }

  #table_card .search {
    width:280px;
    height:40px;
    background-color:#ffffff;
    border:1px solid;
    border-color:#999999;
    border-radius:20px;
    float: right;
    margin-right:40px;
    padding-left: 20px;
  }

  #table_card .search img {
    float: right;
    margin-top: 8px;
    margin-right:20px;
  }

  #table_card .search input {
    margin-top: 4px;
    height:30px;
    width: 210px;
    font-size:18px;
    padding-left: 10px;
    outline: none;
    border: none;
  }

  #table_card .table_wrap {
    height:550px;
  }

  #table_card .page_row {
    padding-left: 30px;
  }

  #table_card .table_wrap table {
    width:96%;
    margin: 0 auto;
    margin-top:30px;
    border-collapse: collapse;
  }

  #table_card .table_wrap table .header {
    font-size:20px;
    font-weight: 500;
    height:50px;
  }

  #table_card .table_wrap table tr:nth-child(n+2) {
    height:50px;
    font-size:18px;
  }

  #table_card .table_wrap table .gray {
    background-color:#eaeaea;
  }

  #table_card .table_wrap table .content {
    font-size:18px;
  }

  #table_card .table_wrap table td {
    text-align: center;
  }

  #table_card .table_wrap table .op {
    color:#ff6f00;
    cursor: pointer;
  }









  .footer{
    height:21px;
    width:80%;
    margin:8.5% auto 0;
    font-size:18px;
    color:rgba(246,248,251,0.90);
    letter-spacing:-0.54px;
    text-align:center;
    font-family: SFUIText-Regular;
  }
  .footer a{
    color:rgba(246,248,251,0.90);
    text-decoration: none;
  }
  .footer a:hover{
    color:#0090D3;
  }
  @media screen and (max-width: 1500px){
    .footer{
      margin:6.5% auto 0;
    }
  }
</style>



// WEBPACK FOOTER //
// ReportList.vue?059c099a